<mat-dialog-content>
  <lemon-dialog-header>
    {{ 'tositteet.maksukortit.lisaa-dialog.otsikko' | translate | async }}
  </lemon-dialog-header>

  <form (ngSubmit)="tallenna()" class="kortti-lomake">
    <app-maksutapa-valinta [valittu]="lomake.maksutapa().value()" (valittuChange)="valitseMaksutapa($event)"></app-maksutapa-valinta>

    <mat-form-field class="kentta">
      <mat-label>{{ 'tositteet.maksukortit.lisaa-dialog.viimeiset4' | translate | async }}</mat-label>
      <input matInput [formField]="lomake.viimeiset4" type="text" inputmode="numeric" autocomplete="off" data-lpignore="true" (input)="siivoaNumero()" />
      <mat-hint>{{ 'tositteet.maksukortit.lisaa-dialog.viimeiset4-vihje' | translate | async }}</mat-hint>
      @if (lomake.viimeiset4().touched() && lomake.viimeiset4().invalid()) {
        <mat-error>{{ 'tositteet.maksukortit.lisaa-dialog.viimeiset4-virhe' | translate | async }}</mat-error>
      }
    </mat-form-field>

    <mat-form-field class="kentta">
      <mat-label>{{ 'tositteet.maksukortit.lisaa-dialog.nimi' | translate | async }}</mat-label>
      <input matInput [formField]="lomake.nimi" type="text" autocomplete="off" data-lpignore="true" />
    </mat-form-field>

    @if (virhe()) {
      <div class="lomake-virhe">{{ virhe() }}</div>
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions style="padding-left: 0; padding-right: 0; justify-content: center">
  <button class="secondarybutton" mat-button type="button" mat-dialog-close>{{ 'yleiset.peruuta' | translate | async }}</button>
  <span style="display: inline-block; width: 8vw; max-width: 4em"></span>
  <button class="primarybutton" mat-button type="button" (click)="tallenna()" [disabled]="lomake().invalid() || tallennetaan()">{{ 'yleiset.tallenna' | translate | async }}</button>
</mat-dialog-actions>
